export const NPA_ALERTS = {
    prs: {
        DELETE_CONFIRM: 'آیا مطمئن هستید حذف گردد؟',
        ADD_SUCCESS: 'معلومات موفقانه ثبت گردید',
        UPDATE_SUCCESS: 'معلومات موفقانه تصحیح گردید',
        CONFIRM_SUCCESS: 'معلومات موفقانه تائید گردید',
        REQUEST_SUCCESS: 'درخواست تائید معلومات موفقانه صورت گرفت',
        REJECT_SUCCESS: 'معلومات رد گردید',
        PUBLISH_SUCCESS: 'معلومات موفقانه در ویب سایت نشرگردید',
        ALREADY_PUBLISHED: 'این درخواست قبلا صورت گرفته است',
        DELETE_SUCCESS: 'معلومات موفقانه حذف گردید',
        ERROR: 'خطا',
        SEARCH_SUCCESS: 'جستجو موفقانه بود',
        GENERAL_SUCCESS: 'عملیات موفقانه اجرا گردید',
        FILE_DOWNLOAD: 'فایل مورد نظر به زودی دانلود خواهد شد',
        SEND_SUCCESS: 'معلومات موفقانه ارسال گردید',
        USER_NOT_CREATED_YET: 'کاربر تا حالا ایجاد نگردیده است',
        INVALID_PIN: 'رمز تثبیت ایمیل نادرست است',
        ALREADY_ACTIVATED: 'کاربر قبلا ایجاد گردیده است',
        NOT_UPLOADED: ' اپلود نگردیده ',
        INVALID_FORMAT: ' فارمت نامعتبر ',
        FILE_SIZE: ' حجم فایل باید کوچکتر از  ',
        BE: ' باشد ',
        LOGO_UPLOAD: 'لوگو آپلود نگردیده',
        NEED_FOR_LOGIN: 'بمنظور دانلود این فایل لطا به سیستم وارد شوید',
        BID_OPENING_NEW_PERIOD: 'دوره جدید آفرگشای موفقانه فعال گردید',
        NO_SIGTAS_DATA: "معلومات تصفیه مالیاتی برای این شماره تشخیصیه مالیاتی در دیتابیس SIGTAS وجود ندارد."
    },
    ps: {
        DELETE_CONFIRM: 'آیا مطمئن هستید حذف گردد؟',
        ADD_SUCCESS: 'معلومات موفقانه ثبت گردید',
        UPDATE_SUCCESS: 'معلومات موفقانه تصحیح گردید',
        CONFIRM_SUCCESS: 'معلومات موفقانه تائید گردید',
        REQUEST_SUCCESS: 'درخواست تائید معلومات موفقانه صورت گرفت',
        REJECT_SUCCESS: 'معلومات رد گردید',
        PUBLISH_SUCCESS: 'موفقانه در ویب سایت نشرگردید',
        ALREADY_PUBLISHED: 'این درخواست قبلا صورت گرفته است',
        DELETE_SUCCESS: 'معلومات موفقانه حذف گردید',
        ERROR: 'خطا',
        SEARCH_SUCCESS: 'جستجو موفقانه بود',
        GENERAL_SUCCESS: 'عملیات موفقانه بود',
        FILE_DOWNLOAD: 'فایل مورد نظر به زودی دانلود خواهد شد',
        SEND_SUCCESS: 'معلومات موفقانه ارسال گردید',
        USER_NOT_CREATED_YET: 'کاربر تا حالا ایجاد نگردیده است',
        INVALID_PIN: 'کود تثبیت ایمیل نادرست است',
        ALREADY_ACTIVATED: 'کاربر قبلا ایجاد گردیده است',
        NOT_UPLOADED: ' نه دی اپلود شوه ',
        INVALID_FORMAT: ' نا معتبره فارمت ',
        FILE_SIZE: ' د فایل اندازه باید د دې څخه  ',
        BE: ' کوچنۍ وي ',
        LOGO_UPLOAD: 'لوګو نه دی پورته شوی',
        NEED_FOR_LOGIN: 'ددی فایل د دانلود کولو لپاره لطفا سیستم ته وردننه شی',
        BID_OPENING_NEW_PERIOD: 'دوره جدید آفرگشای موفقانه فعال گردید',
        NO_SIGTAS_DATA: "د SIGTAS ډیټابیس کې ددی TIN د مالي تصفیه په اړه هیڅ معلومات شتون نلري."
    },
    en: {
        DELETE_CONFIRM: 'Are you sure you want to delete?',
        ADD_SUCCESS: 'Information saved successfully',
        UPDATE_SUCCESS: 'Information edited successfully',
        CONFIRM_SUCCESS: 'Information confirmed successfully',
        REQUEST_SUCCESS: 'Information confirmation requested successfully',
        REJECT_SUCCESS: 'Information was rejected',
        PUBLISH_SUCCESS: 'Information published on website successfully',
        ALREADY_PUBLISHED: 'This request has already been made',
        DELETE_SUCCESS: 'Information deleted successfully',
        ERROR: 'Error',
        SEARCH_SUCCESS: 'Search was successful',
        GENERAL_SUCCESS: 'Operation was successful',
        FILE_DOWNLOAD: 'Desired files will be downloaded soon',
        SEND_SUCCESS: 'Information sent successfully',
        USER_NOT_CREATED_YET: 'User not created yet',
        INVALID_PIN: 'Invalid verification code',
        ALREADY_ACTIVATED: 'User already exists',
        NOT_UPLOADED: ' is not uploaded ',
        INVALID_FORMAT: ' Invalid format ',
        FILE_SIZE: ' File size should be less then ',
        BE: '',
        LOGO_UPLOAD: 'Logo is not uploaded',
        NEED_FOR_LOGIN: 'To download this file please login to the system',
        BID_OPENING_NEW_PERIOD: 'دوره جدید آفرگشای موفقانه فعال گردید',
        NO_SIGTAS_DATA: "There is no Tax clearance data related to this TIN information in SIGTAS database."
    },

};
